/*** IMPORTS FROM imports-loader ***/
var define = false;

require('../../../modules/es.array.sort');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').sort;

